import { Plus, MessageSquare } from 'lucide-react';

function EmptyState({ onNew }: { onNew: () => void }) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center text-center p-8 bg-gray-50">
      <div className="w-24 h-24 bg-white rounded-3xl flex items-center justify-center mb-5 shadow-sm border border-gray-200">
        <MessageSquare size={40} className="text-blue-600" strokeWidth={1.5} />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">Welcome to Chat</h3>
      <p className="text-sm text-gray-500 mb-6 max-w-xs leading-relaxed">Select a conversation from the sidebar or start a new one to begin messaging</p>
      <button onClick={onNew}
        className="px-6 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-semibold hover:bg-blue-700 transition-colors shadow-sm flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
        <Plus size={16} /> New Conversation
      </button>
    </div>
  );
}

export default EmptyState;
